module.exports = __webpack_public_path__ + "static/header-bg-3cfd2c0bd3142886421953edf342d841.png";